import React from "react";
import ResponsiveImage from "./ResponsiveImage";
import { IconArrowDown, IconStar } from "./Icons";

export const Hero = ({ data, rating }) => {
  const title = data?.title || "Welcome to Casa Carmela";
  const paragraph = data?.paragraph || "";

  return (
    <header className="hero" id="top">
      <div className="hero__media">
        <ResponsiveImage
          src="/img/intro-bg.jpg"
          alt="The Amalfi Coast seen from Casa Carmela in Positano"
          sizes="100vw"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
      </div>
      <div className="hero__scrim" aria-hidden="true" />

      <div className="hero__content">
        <p className="hero__eyebrow">Positano · Amalfi Coast</p>

        <h1 className="hero__title">
          {title.replace(/^Welcome to /, "")}
          <br />
          <em>a home above the sea</em>
        </h1>

        <p className="hero__text">{paragraph}</p>

        <div className="hero__actions">
          <a className="btn btn--accent" href="#booking">
            Check availability
          </a>
          <a className="btn btn--light" href="#gallery">
            Explore the house
          </a>
        </div>

        <div className="hero__facts">
          {rating?.score && (
            <span>
              <IconStar filled />
              {rating.score.toFixed(2)} · {rating.count} reviews
            </span>
          )}
          <span>3 bedrooms · 2.5 baths</span>
          <span>Sleeps 6</span>
          <span>Bus stop 50 m</span>
        </div>
      </div>

      <a className="hero__scroll" href="#gallery" aria-label="Scroll to gallery">
        <IconArrowDown />
      </a>
    </header>
  );
};

export default Hero;
